import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {EmailRegex, LandingBusinessCategories, PibRegex} from '../../../constants/general-variables';
import {GeneralHttpService} from '../../../services/http-services/general/general-http.service';
import {ToastrService} from 'ngx-toastr';
import {ActivatedRoute} from '@angular/router';
import {UserRole} from '../../../enums/general-enums';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html'
})
export class ContactComponent implements OnInit {
  contactForm!: FormGroup;
  formTriedToSubmit = false;
  isDropdownOpen = false;
  selectedService: any = null;
  isLoaderActive = false;
  protected readonly LandingBusinessCategories = LandingBusinessCategories;
  protected readonly UserRole = UserRole;

  constructor(private generalHttpService: GeneralHttpService,
              private formBuilder: FormBuilder,
              private activatedRoute: ActivatedRoute,
              private toastService: ToastrService) {
  }

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm(): void {
    this.contactForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.pattern(EmailRegex)]],
      category: ['', Validators.required],
      message: ['', Validators.required],
      user_type: [UserRole.user],
      pib: [''],
    });

    this.contactForm.controls.user_type.valueChanges.subscribe(value => {
      if (value === UserRole.business) {
        this.contactForm.controls.pib.setValidators([Validators.required, Validators.pattern(PibRegex)]);
      } else {
        this.contactForm.controls.pib.clearValidators();
        this.contactForm.controls.pib.patchValue('');
      }
      this.contactForm.updateValueAndValidity();
    });

    this.activatedRoute.params.subscribe((res: any) => {
      if (history.state.isBusiness) {
        this.contactForm.controls.user_type.patchValue(UserRole.business);
      }
    });
  }


  onSelectService(service: any): void {
    this.contactForm.controls.category.patchValue(service.name);
    this.selectedService = service;
  }

  onSubmitContactForm(): any {
    this.formTriedToSubmit = true;
    if (this.contactForm.valid) {
      this.isLoaderActive = true;
      const {pib, ...restContactForm} = this.contactForm.value;
      const reqBody = this.contactForm.controls.user_type.value === UserRole.user ? restContactForm : this.contactForm.value;
      this.generalHttpService.postContactForm(reqBody).then((res: any) => {
        this.toastService.success(res.message);
        this.formTriedToSubmit = false;
        this.isLoaderActive = false;
        this.contactForm.reset();
        this.contactForm.controls.user_type.patchValue(UserRole.user);
      }).catch(error => {
        this.isLoaderActive = false;
        this.toastService.error(error.error.message);
      });
    }
  }
}
